import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CreateNewScrubbingService {

  constructor(private http: HttpClient) { }

  saveScrubbing(baseUrl: string, params: { [key: string]: string | number }): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=mq3y7x`;
    const body = new URLSearchParams();

    Object.keys(params).forEach(key => {
      body.set(key, String(params[key]));
    });

    return this.http.post(url, body.toString(), {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      withCredentials: true
    });
  }
}
